<template>
  <SmallSquare :padding='true' content="1、公众号群发在以下情况会出现发送不成功：（1）用户设置拒收；（2）用户当月已接收超过4条群发消息。
  2、在群发消息编辑过程中会存在新增关注或用户取关的情况，实际群发人数以群发结果为准。" />
  <a-card :bordered="false">
    <a-button class="m-b-20" type="primary" @click="$router.push('/messageCenter/precision/miniCreate')">
      <PlusOutlined />
      新建公众号群发
    </a-button>
    <!-- 时间 -->
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline' :onFinish='pageSearchChange'>
      <a-form-item label="消息内容" name='type'>
        <a-input v-model:value="search.keyword" placeholder="请输入消息内容进行搜索" :style="{'width':'264px'}" />
      </a-form-item>
      <a-form-item label="发送时间" name='keyword'>
        <a-range-picker v-model:value="time" @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button class="m-r-10" type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <span  @click="status(record)"> 详情</span>
              </a-menu-item>
              <a-menu-item>
                <span  @click="del(record)">删除</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <!--<a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
  </a-card>
</template>
<script>
  import { DownOutlined,PlusOutlined } from "@ant-design/icons-vue";
  import { inject, reactive, ref, toRefs } from "vue";
  import { getmessage, createReceiver, delReceiver, receiverDetail, editReceiver } from "@/api/message.js";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    start_time: '',
    end_time: '',
    keyword: ''
  };
  export default {
    components: {
      DownOutlined,PlusOutlined
    },
    setup() {
      const state = reactive({
        time: [],
        listLoading: false,
      })
      let columns = [
        {
          title: "群发对象",
          dataIndex: "app_name",
          key: "app_name",
        },
        {
          title: "消息内容",
          dataIndex: "app_name",
          key: "app_name",
        },
        {
          title: "发送状态",
          dataIndex: "create_time",
          customRender: ({ record }) => {
            return record.sms ? '开启' : '关闭'
          }
        },
        {
          title: "发送数",
          dataIndex: "project",
          key: "project",
        },
        {
          title: "成功数",
          dataIndex: "project",
          key: "project",
        },
        {
          title: "失败数",
          dataIndex: "project",
          key: "project",
        },
        {
          title: "发送时间",
          dataIndex: "project",
          key: "project",
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        },
      ];

      const router = inject('$router')
      const $Modal = inject("$Modal");
      //初始化 分页信息和筛选项信息
      const search = ref({ ...defSearch });
      const data = ref([]);
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getmessage(values).then((res) => res);
        state.listLoading = false;
        data.value = res.data.data;
      };
      //
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value)
      }
      // 删除
      const del = (id) => {
        $Modal.confirm({
          centered: true,
          content: "确定删除当前群发记录吗？",
          onOk: async () => {
            let res = await delReceiver(id).then((res) => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          },
        });
      };
      initData(search.value)
      return {
        columns,
        data,
        ...toRefs(state),
        search,
        onChange
      };
    },
  };
</script>